import { toneVariant, useCompanionNoun } from '@/utils/personalization'
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import type { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  { emoji: '🌊', title: 'pages.onboarding.commStyle.deep', value: 'deep' },
  { emoji: '😄', title: 'pages.onboarding.commStyle.fun', value: 'fun' },
  {
    emoji: '📋',
    title: 'pages.onboarding.commStyle.practical',
    value: 'practical',
  },
  {
    emoji: '💜',
    title: 'pages.onboarding.commStyle.emotional',
    value: 'emotional',
  },
  { emoji: '🎨', title: 'pages.onboarding.commStyle.mix', value: 'mix' },
]

export default function CommStyleQuestionPage() {
  const noun = useCompanionNoun()

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.commStyle.title"
      subtitle={toneVariant('pages.onboarding.commStyle.subtitle')}
      translationInterpolation={{ noun }}
    />
  )
}
